import { render, staticRenderFns } from "./foodLogDetails.vue?vue&type=template&id=50a80efd&scoped=true&"
import script from "./foodLogDetails.vue?vue&type=script&lang=js&"
export * from "./foodLogDetails.vue?vue&type=script&lang=js&"
import style0 from "./foodLogDetails.vue?vue&type=style&index=0&id=50a80efd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a80efd",
  null
  
)

export default component.exports